import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { httpservice, Message } from '../../commons/commons.share';
import { LoginService } from '../../login/login.service';
import { RadniNalog } from '../../_models/RadniNalozi/radninalog';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from 'src/app/_models/user';
import { MatSelectModule } from '@angular/material/select';
import { MatNativeDateModule } from '@angular/material/core';
import { Observable } from 'rxjs';
import { CommonModule, Location } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatDatepicker, MatDatepickerModule } from '@angular/material/datepicker';
import { provideNativeDateAdapter } from '@angular/material/core';
import { KorisnikSelectComponent } from '../../Komunalno/Korisnik/korisnik-select.component';


@Component({
  selector: 'app-radni-nalog-input',
  templateUrl: './radni-nalog-input.component.html',
  styleUrl: './radni-nalog-input.component.css',
  standalone: true,
  imports: [CommonModule, MatCardModule, MatIconModule, MatIcon, MatButtonModule, MatInputModule, MatSelectModule, MatDatepickerModule, FormsModule,KorisnikSelectComponent],
})
export class RadniNalogInputComponent implements OnInit {
  getservice: httpservice;
  data: RadniNalog = { radniNalogId: 0, jedinica: "", vrstaNaloga: "", ime: "", datum: null, datumPrijave: null, izvrsenOpisKvara: "", korisnik: "", kvar: "", mjesto: "", opisKvara: "", prezime: "", rnbroj: "", serviser: "", ulica: "", pjedinica: "", opisRadova: "" };
  loading = false;
  submitted = false;
  status: string = "";
  returnUrl: string;
  error = '';
  editing = false;
  poruka = "Dodavanje";
  loginService: LoginService;
  login: User;
  jedinice: any[];
  vrste: any[];
  serviseri: any[];
  kvarovi: any[];
  skladista: any[];
  korisnik: string;
  @Input() item: 0;
  @Output() newItemEvent = new EventEmitter<RadniNalog>();


  constructor(dataservice: httpservice, private router: Router, private route: ActivatedRoute, private location: Location, loginservice: LoginService) {
    this.getservice = dataservice;
    this.loginService = loginservice;
    this.loginService.currentUser.subscribe(data => {
      this.login = data;
    });
  }

  ngOnInit() {
    this.data.datumPrijave = new Date();
    this.data.datum = new Date();
    this.DohvatiJedinice();
    this.DohvatiVrsteNaloga();
    this.DohvatiVrsteKvarova();
    this.DohvatiServisere();
    this.DohvatiProdajneJedinice();
    console.log("Id=", this.item);

    if (this.item > 0) {
      this.getNalog(this.item.toString());
    }

  }


  OdabirKorisnika(izbor: string) {
    this.getKorisnik(izbor);
  }

  getKorisnik(id: string) {
    this.getservice.GetRequest<Message>("komunalno/korisnik/Get?sifra=" + id).subscribe(result => {
      if (result.status === "success") {
        this.data.ime = result.data.ime;
        this.data.prezime = result.data.prezime;
        this.data.ulica = result.data.ulicaEntity.naziv + " " + result.data.kucniBroj;
        this.data.mjesto = result.data.ulicaEntity.ptt + " " + result.data.ulicaEntity.mjesto;
        this.data.korisnik = result.data.sifra;
      }
    });
  }

  private DohvatiProdajneJedinice() {
    this.getservice.GetRequest<Message>("komunalno/prodajnajedinica/list").subscribe(result => {
      if (result.status === "success") {
        this.skladista = Object.values(result.data);
      }
    });
  }

  private DohvatiServisere() {
    this.getservice.GetRequest<Message>("komunalno/serviser/list").subscribe(result => {
      if (result.status === "success") {
        this.serviseri = Object.values(result.data);
      }
    });
  }

  private DohvatiVrsteKvarova() {
    this.getservice.GetRequest<Message>("komunalno/kvar/list").subscribe(result => {
      if (result.status === "success") {
        this.kvarovi = Object.values(result.data);
      }
    });
  }

  private DohvatiVrsteNaloga() {
    this.getservice.GetRequest<Message>("komunalno/nalog/list").subscribe(result => {
      if (result.status === "success") {
        this.vrste = Object.values(result.data);
      }
    });
  }

  private DohvatiJedinice() {
    this.getservice.GetRequest<Message>("komunalno/jedinica/list").subscribe(result => {
      if (result.status === "success") {
        this.jedinice = Object.values(result.data);
      }
    });
  }

  getNalog(id: string) {
    this.getservice.GetRequest<Message>("radninalozi/get?id=" + id).subscribe(result => {
      if (result.status === "success") {
        this.editing = true;
        this.poruka = "Ispravak";
        this.data = result.data;
        console.log(result.data);
      }
    });
  }

  addNalog() {
    this.submitted = true;
    this.loading = true;
    if (!this.editing) {
      this.getservice.PostRequest<Message>("radninalozi/add", this.data).subscribe(result => {
        if (result.status === "success") {
          this.data.radniNalogId = result.data;
          this.newItemEvent.emit(this.data);
        }
        else {
          console.error('Log error', result);
        }
      },
        error => console.error('Log error', error));
    }
    else {
      this.getservice.PostRequest<Message>("radninalozi/edit", this.data).subscribe(result => {
        if (result.status === "success") {
          this.data.radniNalogId = result.data;
          this.newItemEvent.emit(this.data);
        }
        else {
          console.error('Log error', result);
        }
      }, error => console.error('Log error', error));
    }


  }

  goBack() {
    if (this.editing) {
      if (this.item) {
        this.data.radniNalogId = 0;
        this.newItemEvent.emit(this.data);
      }
      else {
        this.location.back();
      }
    }
    else {
      this.data.radniNalogId = 0;
      this.newItemEvent.emit(this.data);
    }
  }

}
